import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-passwordReassign",
  "use": "icon-passwordReassign-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-passwordReassign\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.873 2.275a.667.667 0 0 0-1.079.784l1.897 2.608H2.667a.667.667 0 0 0 0 1.333H12.69c1.09 0 1.72-1.236 1.078-2.118l-1.896-2.607ZM4.128 13.392a.667.667 0 0 0 1.078-.784L3.309 10h10.024a.667.667 0 0 0 0-1.333H3.31c-1.09 0-1.719 1.236-1.078 2.117l1.897 2.608Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol